module.exports = __webpack_public_path__ + "static/media/valor3.6a091b59.png";